"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.certificateCreation = certificateCreation;
exports.createCertificatePdfToNewWindow = createCertificatePdfToNewWindow;
exports.createPayrollPdfToNewWindow = createPayrollPdfToNewWindow;
exports.createPdfToIFrame = createPdfToIFrame;
exports.createStatementPdfToNewWindow = createStatementPdfToNewWindow;
exports.payrollDirectDepositCreation = payrollDirectDepositCreation;
exports.statementCreation = statementCreation;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _numbers = require("../../helpers/numbers");

var _constants = require("./constants");

var _pdfStyles = require("./pdfStyles");

var _base64Images = require("./base64Images");

var _Logo = _interopRequireDefault(require("./Logo.png"));

var _pdfmake = _interopRequireDefault(require("pdfmake/build/pdfmake"));

var _vfs_fonts = _interopRequireDefault(require("pdfmake/build/vfs_fonts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

_pdfmake["default"].vfs = _vfs_fonts["default"].pdfMake.vfs;
/**
 * For readability I followed this conditionally inserting elements inside the array (https://2ality.com/2017/04/conditional-literal-entries.html)
    const cond = false;
    const arr = [
      ...(cond ? ['a'] : []),
      'b',
    ];
    
  * The unit in pdfmake is point, which seems to be 1/72 of an inch. The document is a letter 8.5 x 11 inches which is 612 × 792 points.
  * 18 points = 1/4"
 */

function statementCreation(statementData, title) {
  // new-new (TransactionDetailData is non-empty for new-old)
  var isNewNew = statementData.TransactionDetailData.length > 0;
  var showYouDontOwnFundsNote = (statementData.Qtr === 1 || statementData.Qtr === 2) && statementData.Yr === 2021 || statementData.Yr < 2021;
  var showSymbolColumnUnderlyingFundBalances = Boolean(statementData.FundData.find(function (data) {
    return data.TickerSymbol;
  })); // find at least one non empty string for symbol

  /* --------------------- BEGIN Page Layout ------------------- */

  var statement = {
    info: {
      title: "".concat(title, " ").concat((0, _dayjs["default"])(statementData.BegDate).format('MM/DD/YYYY'), " to ").concat((0, _dayjs["default"])(statementData.EndDate).format('MM/DD/YYYY')),
      author: 'my529'
    },
    defaultStyle: {
      fontSize: 9
    },
    pageMargins: [25, 15, 30, 40],
    // left, top, right, bottom
    styles: _pdfStyles.pdfStyles,
    content: [{
      // Header
      columns: [{
        width: 130,
        image: _Logo["default"]
      }, {
        width: 100,
        text: _constants.ADDRESS,
        style: 'stackRow'
      }, {
        width: '*',
        stack: [{
          text: [{
            text: 'Phone ',
            bold: true
          }, _constants.PHONE],
          style: 'stackRow'
        }, {
          text: [{
            text: 'Fax ',
            bold: true
          }, _constants.FAX],
          style: 'stackRow'
        }, {
          text: [{
            text: 'Email ',
            bold: true
          }, _constants.EMAIL],
          style: 'stackRow'
        }]
      }, {
        width: '*',
        stack: [{
          text: [{
            text: 'Website ',
            bold: true
          }, {
            text: _constants.HOSTNAME,
            link: "https://".concat(_constants.HOSTNAME)
          }],
          style: 'stackRow'
        }, {
          text: [{
            text: 'Hours ',
            bold: true
          }, _constants.HOURS],
          style: 'stackRow'
        }]
      }],
      columnGap: 10
    }, // horizontal line 
    {
      canvas: [{
        type: 'line',
        x1: 0,
        y1: 5,
        x2: 595 - 2 * 40,
        y2: 5,
        lineWidth: 1,
        color: _pdfStyles.colors.primaryColor
      }]
    }, // space between
    {
      text: '',
      style: 'spaceBetween'
    }, // Recipient name and address and statement details
    {
      columns: [// Recipient name and address for mailing purposes
      {
        width: 320,
        // letter width is 612
        stack: [{
          text: statementData.RecipientName,
          style: 'stackRow'
        }].concat(_toConsumableArray(statementData.StreetAddress1 ? [{
          text: statementData.StreetAddress1,
          style: 'stackRow'
        }] : []), _toConsumableArray(statementData.StreetAddress2 ? [{
          text: statementData.StreetAddress2,
          style: 'stackRow'
        }] : []), _toConsumableArray(statementData.StreetAddress3 ? [{
          text: statementData.StreetAddress3,
          style: 'stackRow'
        }] : []), [{
          text: "".concat(statementData.City, ", ").concat(statementData.State, " ").concat(statementData.PostalCode),
          style: 'stackRow'
        }], _toConsumableArray(statementData.Country ? [{
          text: statementData.Country,
          style: 'stackRow'
        }] : [])),
        margin: [50, 55, 0, 75] // left, top, right, bottom - position address so it shows correctly in an envelope window (matched the old pdf)

      }, // Quarterly account statement for new-new
      {
        width: '*',
        stack: [{
          text: 'Quarterly account statement',
          style: 'title'
        }, // top is a white space to position the address in an envelope window
        {
          text: "".concat((0, _dayjs["default"])(statementData.BegDate).format('LL'), " to ").concat((0, _dayjs["default"])(statementData.EndDate).format('LL')),
          style: 'datumSpan'
        }, isNewNew ? pdfTable({
          alignments: ['left', 'left'],
          widths: ['auto', '*'],
          keys: ['title', 'value'],
          rows: [{
            title: 'Account Number',
            value: statementData.AccountNumber
          }, {
            title: 'Investment Option',
            value: statementData.InvestmentOption
          }, {
            title: 'Date Opened',
            value: (0, _dayjs["default"])(statementData.AgreementDate).format('MM/DD/YYYY')
          }, {
            title: 'Account Owner/Agent',
            value: statementData.AccountOwnerName
          }, {
            title: 'Beneficiary',
            value: statementData.BeneficiaryName
          }, {
            title: 'Limited Power of Attorney',
            value: statementData.POAName ? statementData.POAName : 'N/A'
          }]
        }) : pdfTable({
          alignments: ['left', 'left'],
          widths: ['auto', '*'],
          keys: ['title', 'value'],
          rows: [{
            title: {
              text: 'Ending Balance',
              bold: true
            },
            value: {
              text: (0, _numbers.currencyFormatter)(statementData.EndingBalance),
              bold: true,
              alignment: 'right'
            }
          }, {
            title: 'Account Number',
            value: statementData.AccountNumber
          }, {
            title: 'Investment Option',
            value: statementData.InvestmentOption
          }, {
            title: 'Account Owner/Agent',
            value: statementData.AccountOwnerName
          }, {
            title: 'Beneficiary',
            value: statementData.BeneficiaryName
          }, {
            title: 'Limited Power of Attorney',
            value: statementData.POAName ? statementData.POAName : 'N/A'
          }, {
            title: 'Net Principal Contributions',
            value: {
              text: (0, _numbers.currencyFormatter)(statementData.NetPrincipalContributions),
              alignment: 'right'
            }
          }, {
            title: 'Tax Year To Date Contributions',
            value: {
              text: (0, _numbers.currencyFormatter)(statementData.TaxYearContributions),
              alignment: 'right'
            }
          }, {
            title: 'Previous Tax Year Contributions',
            value: {
              text: (0, _numbers.currencyFormatter)(statementData.PriorYearContributions),
              alignment: 'right'
            }
          }]
        })]
      }]
    }, // space between
    {
      text: '',
      style: 'spaceBetween'
    }, // Message1 in a text box
    statementData.Message1 && textBoxMessage(statementData.Message1.HtmlMessageText), // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // Investment options table
    isNewNew ? pdfTable({
      title: "Investment option as of ".concat((0, _dayjs["default"])(statementData.EndDate).format('LL')),
      headers: ['Portfolio', 'Symbol', 'NAV', 'Units', 'Cost Basis', 'Amount'],
      keys: ['FundName', 'TickerSymbol', 'Price', 'Units', 'CostBasis', 'Amount'],
      widths: ['auto', '*', '*', '*', '*', '*'],
      alignments: ['left', 'left', 'right', 'right', 'right', 'right'],
      rows: statementData.IsCustom ? [{
        FundName: {
          text: statementData.InvestmentOption,
          style: 'investmentOptionLabel'
        },
        TickerSymbol: '',
        Price: '',
        Units: '',
        CostBasis: {
          text: (0, _numbers.currencyFormatter)(statementData.NetPrincipalContributions),
          style: 'investmentOptionLabel'
        },
        Amount: {
          text: (0, _numbers.currencyFormatter)(statementData.EndingBalance),
          style: 'investmentOptionLabel'
        }
      }].concat(_toConsumableArray(statementData.FundData.map(function (fundData) {
        return {
          FundName: "\u200B\t".concat(fundData.FundName),
          // required indent
          TickerSymbol: fundData.TickerSymbol,
          Price: (0, _numbers.currencyFormatter)(fundData.Price, 4),
          Units: (0, _numbers.numberFormatter)(fundData.Units, 5),
          CostBasis: '',
          Amount: {
            text: (0, _numbers.currencyFormatter)(fundData.Amount)
          }
        };
      }))) : statementData.FundData.map(function (fundData) {
        return {
          FundName: {
            text: fundData.FundName,
            bold: true
          },
          TickerSymbol: fundData.TickerSymbol,
          Price: (0, _numbers.currencyFormatter)(fundData.Price, 4),
          Units: (0, _numbers.numberFormatter)(fundData.Units, 5),
          CostBasis: (0, _numbers.currencyFormatter)(statementData.NetPrincipalContributions),
          Amount: {
            text: (0, _numbers.currencyFormatter)(statementData.EndingBalance),
            bold: true
          }
        };
      })
    }) : pdfTable({
      underText: showYouDontOwnFundsNote ? 'This is what my529 owns on your behalf. You do not own the listed funds. You own my529 units.' : null,
      title: "Underlying Fund Balances as of ".concat((0, _dayjs["default"])(statementData.EndDate).format('LL')),
      headers: showSymbolColumnUnderlyingFundBalances ? ['Fund', 'Symbol', 'Price', 'my529Units', 'Amount'] : ['Fund', 'Price', 'my529Units', 'Amount'],
      keys: showSymbolColumnUnderlyingFundBalances ? ['FundName', 'TickerSymbol', 'Price', 'Units', 'Amount'] : ['FundName', 'Price', 'Units', 'Amount'],
      widths: showSymbolColumnUnderlyingFundBalances ? ['auto', '*', '*', '*', '*'] : ['auto', '*', '*', '*'],
      alignments: showSymbolColumnUnderlyingFundBalances ? ['left', 'left', 'right', 'right', 'right'] : ['left', 'right', 'right', 'right'],
      rows: showSymbolColumnUnderlyingFundBalances ? statementData.FundData.map(function (fundData) {
        return {
          FundName: fundData.FundName,
          TickerSymbol: fundData.TickerSymbol,
          Price: (0, _numbers.currencyFormatter)(fundData.Price, 4),
          Units: (0, _numbers.numberFormatter)(fundData.Units, 5),
          Amount: (0, _numbers.currencyFormatter)(fundData.Amount) // pulled from the header data

        };
      }) : statementData.FundData.map(function (fundData) {
        return {
          FundName: fundData.FundName,
          Price: (0, _numbers.currencyFormatter)(fundData.Price, 4),
          Units: (0, _numbers.numberFormatter)(fundData.Units, 5),
          Amount: (0, _numbers.currencyFormatter)(fundData.Amount) // pulled from the header data

        };
      })
    }), // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // Activity summary table
    pdfTable({
      title: 'Activity summary',
      headers: ['', 'This quarter', 'Year to date'],
      alignments: ['left', 'right', 'right'],
      widths: ['*', '*', '*'],
      keys: ['AmountName', 'QuarterAmount', 'YearToDateAmount'],
      showTotalLine: true,
      rows: [{
        AmountName: {
          text: 'Beginning Balance',
          bold: true
        },
        QuarterAmount: {
          text: (0, _numbers.currencyFormatter)(statementData.BeginningBalance),
          bold: true
        },
        YearToDateAmount: {
          text: (0, _numbers.currencyFormatter)(statementData.YTDBeginningBalance),
          bold: true
        }
      }, {
        AmountName: 'Contributions',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.Contributions),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDContributions)
      }].concat(_toConsumableArray(!isNewNew ? [{
        AmountName: 'my529 Dividends',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.Dividends),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDDividends)
      }] : []), [{
        AmountName: 'Withdrawals',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.Withdrawals),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDWithdrawals)
      }], _toConsumableArray(!isNewNew ? [{
        AmountName: 'Transfers/Exchanges *',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.Transfers),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDTransfers)
      }] : [{
        AmountName: 'Other Transactions *',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.Transfers),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDTransfers)
      }]), [{
        AmountName: 'Gain/(Loss)',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.GainLoss),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDGainLoss)
      }], _toConsumableArray(!isNewNew ? [{
        AmountName: 'Asset/Transaction Fees',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.AssetFee),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDAssetFee)
      }] : []), _toConsumableArray(!isNewNew ? [{
        AmountName: 'Mail Delivery Fee',
        QuarterAmount: (0, _numbers.currencyFormatter)(statementData.MailFee),
        YearToDateAmount: (0, _numbers.currencyFormatter)(statementData.YTDMailFee)
      }] : []), [{
        AmountName: {
          text: 'Ending Balance',
          bold: true
        },
        QuarterAmount: {
          text: (0, _numbers.currencyFormatter)(statementData.EndingBalance),
          bold: true
        },
        YearToDateAmount: {
          text: (0, _numbers.currencyFormatter)(statementData.EndingBalance),
          bold: true
        }
      }]),
      footnote: !isNewNew ? '* Includes transfers between my529 accounts, reallocations, rebalances, investment option changes and fund changes.' : '* Includes all other transactions (e.g., transfers, rebalances, investment option changes, transaction fees).'
    }), // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // Transactions detail
    !isNewNew ? pdfTable({
      title: 'Transaction detail',
      headers: ['Date', 'Description', 'Amount'],
      keys: ['Date', 'Description', 'Amount'],
      widths: ['*', 'auto', '*'],
      alignments: ['left', 'left', 'right'],
      showTotalLine: true,
      rows: _toConsumableArray(statementData.TransactionData.map(function (transaction, index, array) {
        var description = transaction.FundName ? "".concat(transaction.Type, " - ").concat(transaction.FundName) : transaction.Type; // the first row is the beginning balance last row is the ending balance

        var item;

        if (index === 0 || index === array.length - 1) {
          item = {
            Date: {
              text: (0, _dayjs["default"])(transaction.Date).format('MM/DD/YYYY'),
              bold: true
            },
            Description: {
              text: description,
              bold: true
            },
            Amount: {
              text: (0, _numbers.currencyFormatter)(transaction.Amount),
              bold: true
            }
          };
        } else {
          item = {
            Date: (0, _dayjs["default"])(transaction.Date).format('MM/DD/YYYY'),
            Description: description,
            Amount: (0, _numbers.currencyFormatter)(transaction.Amount)
          };
        }

        return item;
      }))
    }) : pdfTable({
      title: 'Transaction detail',
      headers: ['Date', 'Description', 'Symbol', 'NAV', 'Units', 'Amount'],
      alignments: ['left', 'left', 'left', 'right', 'right', 'right'],
      widths: ['auto', 'auto', '*', '*', '*', '*'],
      keys: ['Date', 'Description', 'Symbol', 'NAV', 'Units', 'Amount'],
      showTotalLine: true,
      rows: _toConsumableArray(statementData.TransactionDetailData // OrderIdentity should be used to determine the order of entities
      .sort(function (transactionA, transactionB) {
        return transactionA.OrderIdentity - transactionB.OrderIdentity;
      }).map(function (transaction, index, array) {
        var item; // the first row is the beginning balance last row is the ending balance

        if (index === 0 || index === array.length - 1) {
          item = {
            Date: {
              text: (0, _dayjs["default"])(transaction.Date).format('MM/DD/YYYY'),
              bold: true
            },
            Description: {
              text: transaction.Description,
              bold: true
            },
            Symbol: {
              text: transaction.Symbol,
              bold: true
            },
            NAV: {
              text: (0, _numbers.currencyFormatter)(transaction.NAV, 4),
              bold: true
            },
            Units: {
              text: (0, _numbers.numberFormatter)(transaction.Units, 5),
              bold: true
            },
            Amount: {
              text: (0, _numbers.currencyFormatter)(transaction.Amount),
              bold: true
            }
          };
        } else {
          item = {
            Date: (0, _dayjs["default"])(transaction.Date).format('MM/DD/YYYY'),
            Description: transaction.Description,
            Symbol: transaction.Symbol,
            NAV: (0, _numbers.currencyFormatter)(transaction.NAV, 4),
            Units: (0, _numbers.numberFormatter)(transaction.Units, 5),
            Amount: (0, _numbers.currencyFormatter)(transaction.Amount)
          };
          item = {
            Date: (0, _dayjs["default"])(transaction.Date).format('MM/DD/YYYY'),
            Description: transaction.Description,
            Symbol: transaction.Symbol,
            NAV: (0, _numbers.currencyFormatter)(transaction.NAV, 4),
            Units: (0, _numbers.numberFormatter)(transaction.Units, 5),
            Amount: (0, _numbers.currencyFormatter)(transaction.Amount)
          };
        }

        return item;
      }))
    }), // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // Message3 in a text box
    statementData.Message3 && textBoxMessage(statementData.Message3.HtmlMessageText)]
  };
  /* --------------------- END Page Layout ------------------- */

  return statement;
}
/* ---------------------  Account Certificate PDF creation ------------------- */


function certificateCreation(certificateData) {
  var certificate = {
    info: {
      title: 'my529 Account Certificate',
      author: 'my529'
    },
    defaultStyle: {
      fontSize: 9
    },
    pageOrientation: 'landscape',
    styles: _pdfStyles.pdfStyles,
    background: function background(currentPage, pageSize) {
      var lineWidth = 20;
      return [{
        canvas: [{
          type: 'line',
          x1: 1,
          y1: 11,
          x2: pageSize.width - 1,
          y2: 11,
          lineWidth: lineWidth,
          lineColor: _pdfStyles.colors.black
        }, //Top line
        {
          type: 'line',
          x1: 11,
          y1: 11,
          x2: 11,
          y2: pageSize.height - 11,
          lineWidth: lineWidth,
          lineColor: _pdfStyles.colors.black
        }, //Left line
        {
          type: 'line',
          x1: 1,
          y1: pageSize.height - 11,
          x2: pageSize.width - 1,
          y2: pageSize.height - 11,
          lineWidth: lineWidth,
          lineColor: _pdfStyles.colors.black
        }, //Bottom line
        {
          type: 'line',
          x1: pageSize.width - 11,
          y1: 11,
          x2: pageSize.width - 11,
          y2: pageSize.height - 11,
          lineWidth: lineWidth,
          lineColor: _pdfStyles.colors.black
        } //Right line
        ]
      }];
    },
    content: [{
      columns: [// left portion
      {
        width: 300,
        margin: [0, 200, 10, 200],
        // left, top, right, bottom
        stack: [{
          image: _base64Images.my529_logo,
          width: 230,
          style: 'my529Logo'
        }, {
          text: [{
            text: 'Y O U R   E D U C A T I O N A L   S A V I N G S   P L A N',
            fontSize: 11,
            color: _pdfStyles.colors.darkGray,
            alignment: 'center'
          }]
        }]
      }, // vertical divider line
      {
        canvas: [{
          type: 'line',
          x1: 5,
          y1: 0,
          x2: 5,
          y2: 595 - 2 * 40,
          lineWidth: 1,
          color: _pdfStyles.colors.darkGray
        }]
      }, // right portion
      {
        width: 450,
        margin: [0, 40],
        alignment: 'center',
        stack: [{
          text: [{
            text: 'm y 5 2 9   C E R T I F I C A T E',
            fontSize: 16
          }]
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: [{
            text: 'presented to',
            fontSize: 11
          }]
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: [{
            text: certificateData.BeneficiaryName.toUpperCase(),
            fontSize: 22,
            bold: true
          }]
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: [{
            text: 'An educational savings account has been established for you by',
            fontSize: 11
          }]
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: [{
            text: certificateData.PresentedBy.toUpperCase(),
            fontSize: 20,
            bold: true
          }]
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          columns: [{
            // left portion with State Seal
            width: 180,
            alignment: 'center',
            stack: [{
              image: _base64Images.utahStateSeal_logo,
              width: 100,
              height: 100
            }, {
              text: '',
              style: 'spaceBetween'
            }, {
              text: '',
              style: 'spaceBetween'
            }, {
              text: [{
                text: 'PLAN SPONSOR',
                fontSize: 11,
                alignment: 'center'
              }]
            }]
          }, {
            // right portion with USHE logo
            width: 270,
            alignment: 'center',
            stack: [{
              image: _base64Images.ushe_logo,
              width: 220,
              height: 100
            }, {
              text: '',
              style: 'spaceBetween'
            }, {
              text: '',
              style: 'spaceBetween'
            }, {
              text: [{
                text: 'PLAN ADMINISTRATOR',
                fontSize: 11,
                alignment: 'center'
              }]
            }]
          }]
        }]
      }]
    }]
  };
  return certificate;
}
/* ---------------------  Account Certificate PDF creation ------------------- */


function payrollDirectDepositCreation(payrollData) {
  var payrollDirectDeposit = {
    info: {
      title: 'my529 Payroll Direct Deposit Request',
      author: 'my529'
    },
    defaultStyle: {
      fontSize: 9
    },
    styles: _pdfStyles.pdfStyles,
    content: [{
      // Header
      stack: [{
        columnGap: 10,
        columns: [{
          width: 130,
          image: _Logo["default"]
        }, {
          width: 100,
          text: _constants.ADDRESS,
          margin: [0, 9, 0, 0]
        }]
      }, {
        columns: [{
          width: 450,
          text: [{
            text: 'Payroll Direct Deposit Request',
            bold: true,
            fontSize: '15'
          }, {
            text: ' - To be given to your employer',
            bold: true,
            fontSize: '11'
          }]
        }, {
          text: (0, _dayjs["default"])().format('MM/DD/YYYY'),
          alignment: 'right',
          margin: [0, 5, 0, 0]
        }]
      }]
    }, // horizontal line 
    {
      canvas: [{
        type: 'line',
        x1: -10,
        y1: 5,
        x2: 595 - 2 * 35,
        y2: 5,
        lineWidth: 3,
        color: _pdfStyles.colors.black
      }]
    }, // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // account owner and bank info
    {
      columns: [// account owner info
      {
        width: 300,
        margin: [10, 20, 0, 20],
        stack: [{
          text: 'my529 Account Owner',
          bold: true
        }, {
          text: '',
          style: 'spaceBetween'
        }, {
          text: payrollData.agentName.toUpperCase(),
          style: 'stackRow'
        }, {
          text: payrollData.address.StreetAddress1.toUpperCase(),
          style: 'stackRow'
        }, {
          text: "".concat(payrollData.address.City.toUpperCase(), ", ").concat(payrollData.address.State.toUpperCase(), ", ").concat(payrollData.address.PostalCode),
          style: 'stackRow'
        }]
      }, // bank info
      {
        width: 300,
        stack: [pdfTable({
          alignments: ['left', 'left'],
          widths: ['auto', '*'],
          keys: ['title', 'value'],
          rows: [{
            title: 'Amount',
            value: (0, _numbers.currencyFormatter)(payrollData.totalAmount),
            boldTitle: true
          }, {
            title: 'Employer',
            value: payrollData.Employer,
            boldTitle: true
          }, {
            title: 'Bank Name',
            value: payrollData.PayrollBankName,
            boldTitle: true
          }, {
            title: 'Routing Number',
            value: payrollData.PayrollRoutingNumber,
            boldTitle: true
          }, {
            title: 'Bank Account Number',
            value: payrollData.PayrollBankAccountNumber,
            boldTitle: true
          }, {
            title: 'Bank Account Type',
            value: {
              text: payrollData.PayrollBankAccountType,
              bold: true,
              italics: true
            },
            boldTitle: true
          }]
        })]
      }]
    }, // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // horizontal line 
    {
      canvas: [{
        type: 'line',
        x1: -10,
        y1: 5,
        x2: 595 - 2 * 35,
        y2: 5,
        lineWidth: 3,
        color: _pdfStyles.colors.black
      }]
    }, // space between
    {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: '',
      style: 'spaceBetween'
    }, // legal info
    {
      text: 'Important:',
      bold: true
    }, {
      text: 'The bank account information provided above is to be used strictly to fund the my529 account(s) specified by the above-named person through the means of payroll direct deposit. Any other use of this information is prohibited. The user of this information is liable for losses incurred by its fraudulent use or dissemination.'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: 'Employer:',
      bold: true
    }, {
      text: 'You or your employee should use the above information to set up an additional direct deposit from the employee\'s paycheck. Please send after-tax funds by automated contribution (ACH) to the above routing and bank account number.'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: 'my529\'s payroll direct deposit is facilitated via an ACH transaction to U.S. Bank and may appear as an additional direct deposit on your employee\'s paycheck.'
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: "If you have any questions regarding the payroll direct deposit process or about my529, please contact my529 toll-free at ".concat(_constants.PHONE, " on ").concat(_constants.HOURS, " or by e-mail at ").concat(_constants.EMAIL, ".")
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: 'Employee: As a reminder, when you authorized payroll direct deposit, you agreed to the following:',
      bold: true
    }, {
      margin: [10, 0, 0, 0],
      ul: ['The bank account number above is only to be used for payroll direct deposits and may not be used to make electronic contributions into my529 from a checking or savings account.', 'The above amount will be deducted from my paycheck each pay period.', 'If I no longer wish to participate in payroll direct deposit, I must stop payroll direct deposit with my employer.', 'This request revokes and replaces any previous my529 payroll direct deposit request that I have submitted. It will remain in effect until cancelled or replaced.', 'my529 will apply the funds received from my employer to my my529 account(s) according to the current account distribution percentages on record with my529. I also acknowledge that any changes I make that affect the ownership or status of my my529 accounts will change my current percentages.', 'Each pay period, my employer will reduce my after-tax compensation by the total amount shown above and remit such amount to my529 for deposit into the designated my529 account(s).', 'This payroll direct deposit amount will not be invested with my529 until my529 receives the funds from my employer.', 'I have read the my529 Program Description and considered all investment objectives, risks, charges, and expenses.', 'Investments are not guaranteed by my529, the State Board of Regents, the Utah Higher Education Assistance Authority (UHEAA), or any other state or federal agency. However, FDIC insurance is provided for the FDIC-insured savings account. I understand that my investment could lose value.']
    }, {
      text: '',
      style: 'spaceBetween'
    }, {
      text: 'Non-Account Owner Contributors: As a reminder, when you authorized payroll direct deposit, you agreed to the following:',
      bold: true
    }, {
      text: 'Only the my529 account owner may receive Utah State income tax benefits for money contributed to a my529 account. If you are not the my529 account owner of the account to which you are contributing, you will not receive the Utah State income tax benefit and you will not have any control over the money contributed to the my529 account.'
    }]
  };
  return payrollDirectDeposit;
}
/* ---------------------  PDF HELPER METHODS ------------------- */


function textBoxMessage(msgText) {
  return {
    table: {
      widths: ['*'],
      body: [[msgText]]
    },
    layout: {
      hLineWidth: function hLineWidth() {
        return 0;
      },
      vLineWidth: function vLineWidth() {
        return 0;
      },
      paddingLeft: function paddingLeft() {
        return 10;
      },
      paddingRight: function paddingRight() {
        return 10;
      },
      paddingTop: function paddingTop() {
        return 10;
      },
      paddingBottom: function paddingBottom() {
        return 10;
      }
    },
    style: 'messageBox'
  };
}

function pdfTable(_ref) {
  var _ref$underText = _ref.underText,
      underText = _ref$underText === void 0 ? null : _ref$underText,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? [] : _ref$headers,
      alignments = _ref.alignments,
      widths = _ref.widths,
      keys = _ref.keys,
      rows = _ref.rows,
      _ref$showTotalLine = _ref.showTotalLine,
      showTotalLine = _ref$showTotalLine === void 0 ? false : _ref$showTotalLine,
      _ref$footnote = _ref.footnote,
      footnote = _ref$footnote === void 0 ? null : _ref$footnote;
  var body = [];
  var numOfHeaders = 0;
  var numOfRows = 0; // add under text if available

  if (underText) {
    numOfHeaders++;
    body.push(keys.map(function (key, index) {
      // pdfmake needs remaining empty cells when doing calSpan
      return index === 0 ? {
        text: underText,
        colSpan: keys.length,
        bold: true,
        alignment: 'left',
        border: [false, false, false, false],
        style: 'underText'
      } : {};
    }));
  } // add a title if available


  if (title) {
    numOfHeaders++;
    body.push(keys.map(function (key, index) {
      // pdfmake needs remaining empty cells when doing calSpan
      return index === 0 ? {
        text: title,
        colSpan: keys.length,
        bold: true,
        alignment: 'left',
        border: [false, false, false, false],
        style: 'title'
      } : {};
    }));
  } // add headers if not empty


  if (headers.length > 0) {
    numOfHeaders++; // headers bold

    body.push(headers.map(function (header, index) {
      return {
        text: header,
        bold: true,
        alignment: alignments[index],
        border: [false, false, false, true]
      };
    }));
  } // show not available of no data for rows


  if (rows.length > 0) {
    numOfRows = rows.length;
    rows.forEach(function (row, rowIndex, array) {
      var border = showTotalLine && array.length - 2 === rowIndex ? [false, false, false, true] : [false, false, false, false];
      var rowOfStringCells = keys.map(function (key, colIndex) {
        return {
          text: row[key],
          alignment: alignments[colIndex],
          border: border,
          bold: key === 'title' && row.boldTitle
        };
      });
      body.push(rowOfStringCells);
    });
  } else {
    body.push(keys.map(function (key, index) {
      // pdfmake needs remaining empty cells when doing calSpan
      return index === 0 ? {
        text: 'No data available',
        colSpan: keys.length,
        alignment: 'center',
        border: [false, false, false, false],
        style: 'noDataAvailable'
      } : {};
    }));
  } // add a footnote if available


  if (footnote) {
    numOfRows++;
    body.push(keys.map(function (key, index) {
      // pdfmake needs remaining empty cells when doing calSpan
      return index === 0 ? {
        text: footnote,
        colSpan: keys.length,
        bold: true,
        alignment: 'left',
        border: [false, false, false, false],
        style: 'footnote'
      } : {};
    }));
  } // if too many rows kept with the header it would not fit page and not show at all, if too little it would show too big part of page empty


  var keepWithHeaderRows = numOfRows < 30 ? numOfRows : 30;
  return {
    table: _objectSpread(_objectSpread(_objectSpread({}, numOfHeaders ? {
      headerRows: numOfHeaders
    } : {}), {}, {
      // if 0 header rows don't include this prop
      dontBreakRows: true
    }, numOfHeaders ? {
      keepWithHeaderRows: keepWithHeaderRows
    } : {}), {}, {
      // if 0 header rows don't include this prop
      widths: widths,
      body: body
    })
  };
}
/* ---------------------  CREATE PDF METHODS ------------------- */


function createStatementPdfToNewWindow(statementData, window, title) {
  _pdfmake["default"].createPdf(statementCreation(statementData, title)).open({}, window);
}

function createCertificatePdfToNewWindow(certificateData, window) {
  _pdfmake["default"].createPdf(certificateCreation(certificateData)).open({}, window);
}

function createPayrollPdfToNewWindow(payrollData, window) {
  _pdfmake["default"].createPdf(payrollDirectDepositCreation(payrollData)).open({}, window);
} // this is for development only insert method call to componentDidMount to have live updates on pdfmake changes
// and in render <iframe id='pdfV' style={{ width: '100%', height: '1000px' }} /> 


function createPdfToIFrame(statementData, iFrameId) {
  _pdfmake["default"].createPdf(statementCreation(statementData)).getDataUrl(function (outDoc) {
    document.getElementById(iFrameId).src = outDoc;
  });
}